import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {PickArtifactCreaturesNavPanel} from "@/scenes.ui/pick-artifact-creatures-nav-panel";
import {Creature} from "@/store/level/types";
import CreaturePanel from "@/scenes.ui/creature-panel";
import {Keys} from "@/constants/key";
import SoundUtils from "@/utils/sound-utils";

export class CreaturePickPanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, creatures: Creature[], desiredCreature: Creature,
                callback: (desiredCreatureId: number, currentCreatureId: number) => unknown) {
        super(scene, canvas, Tr('zamena.geroja'));

        let clickSound = SoundUtils.addSound(scene, Keys.SOUND_BUTTON_CLICK);

        let choseCreatureText = TextUtils.addTextByFamily(scene, Tr('viberite.na.kogo.zamenit'),
            0, 0, '#fff4da', 13, 'normal', 350, Fonts.ARIAL_MT);

        let targetCreaturePanel = new CreaturePanel(scene, 0, -120, desiredCreature, () => {}, true);
        targetCreaturePanel.setHealthVisible();

        let creaturesNavPanel = new PickArtifactCreaturesNavPanel(scene, canvas, 0, 130, creatures, (currentCreatureId: number) => {
            SoundUtils.play(clickSound);
            if (callback != null) {
                callback(desiredCreature.id, currentCreatureId);
            }
            this.close();
        });

        this.add([choseCreatureText, targetCreaturePanel, creaturesNavPanel]);
    }
}
